module.exports = "/_next/static/images/wp-logo-870ff14edd31b36e129c6a69498c0dfa.png";